(function () {
  'use strict';
  var app = document.getElementById('app');
  if (!app) return;
  function syncClear(filters, clear) {
    var search = filters.querySelector('input[type="search"]');
    var commune = filters.querySelector('select');
    var kinds = filters.querySelectorAll('.directory-filter');
    clear.hidden = !(search && search.value || commune && commune.value || Array.prototype.some.call(kinds, function (button, index) { return index > 0 && button.getAttribute('aria-pressed') === 'true'; }));
  }
  function enhance() {
    if (app.classList.contains('directory-page')) {
      var filters = app.querySelector('.directory-filters');
      var reset = app.querySelector('.directory-empty .directory-reset');
      if (filters && reset && !filters.querySelector('.directory-clear')) {
        var clear = reset.cloneNode(true);
        clear.className = 'directory-clear';
        clear.hidden = true;
        clear.addEventListener('click', function () { reset.click(); update(); });
        filters.append(clear);
        function update() { syncClear(filters, clear); }
        filters.addEventListener('input', update);
        filters.addEventListener('change', update);
        filters.addEventListener('click', update);
        update();
      }
      if (filters && filters.querySelector('.directory-clear')) syncClear(filters, filters.querySelector('.directory-clear'));
    }
    if (app.classList.contains('public-shop-root')) {
      var empty = app.querySelector('.public-shop-empty');
      var back = app.querySelector('.public-shop-back-nav .public-shop-all');
      if (empty && back && !empty.querySelector('.public-shop-all')) {
        empty.append(document.createElement('br'), back.cloneNode(true));
      }
    }
  }
  enhance();
  new MutationObserver(enhance).observe(app, { childList: true, subtree: true });
})();
